var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-list"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('order-list-table')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }